import { useEffect } from "react";
import "./AboutBanner.css";
import aboutImage1 from "../../assets/aboutUspage/about-us2.png";
import { FloatingWhatsApp } from "react-floating-whatsapp";
import { whatsAppBotListener } from "../../utils/Utils";
import { PHONE_NUMBER } from "../../utils/Constant";
import clinicIcon from "../../assets/rohan-systems-pics/logo.png";

// Directors Images
import director1 from "../../assets/ceoPics/DyandeoPatilNew.png";
import director2 from "../../assets/ceoPics/gorakhpatilDirector.jpg";

const AboutBanner = () => {

  useEffect(() => {
          window.scrollTo({ top: 0, behavior: "smooth" });
   },);
    
  return (
    <section id="aboutUsPageId" className="aboutUsSectionPage common-padding">
      <div className="container">
        {/* Title */}
        <div className="section-titlesa">
          <h1>About Us – Rohan Systems</h1>
          <p className="subtitle">
            Technology and security are more than just tools—they are the foundation
            of trust, growth, and progress.
          </p>
        </div>

        {/* Our Journey */}
        <div className="about-block journey-block">
          <div className="journey-content">
            <h2>Our Journey</h2>
            <p>
              Founded with the vision to make technology more accessible and security
              more reliable, Rohan Systems has consistently evolved with changing times.
              From selling and servicing computers in our early days, we have expanded
              into a comprehensive solutions provider that offers not only IT sales and
              repairs but also advanced CCTV installations, networking solutions,
              and customized IT support.
            </p>
          </div>

          <div className="journey-image">
            <img src={aboutImage1} alt="Our Journey" className="aboutusImage" />
          </div>
        </div>

        {/* What We Do */}
        <div className="about-block whatwedo">
          <h2>What We Do</h2>
          <ul>
            <li>
              <strong>Computers & Laptops:</strong> Latest laptops, desktops, and IT
              hardware tailored to performance and budget.
            </li>
            <li>
              <strong>Repair & Maintenance:</strong> Quick, reliable repairs and
              ongoing maintenance for smooth operations.
            </li>
            <li>
              <strong>Accessories & Peripherals:</strong> Genuine, high-quality IT
              products and components.
            </li>
            <li>
              <strong>CCTV & Security Systems:</strong> Design, installation, and
              maintenance of surveillance solutions.
            </li>
            <li>
              <strong>Networking Solutions:</strong> Secure, efficient networks for
              businesses and households.
            </li>
            <li>
              <strong>Custom IT Services:</strong> Tailored IT support plans to ensure
              efficiency and peace of mind.
            </li>
          </ul>
        </div>

        {/* Why Choose */}
        <div className="about-block highlight whywe">
          <h2>Why Choose Rohan Systems?</h2>
          <p>
            With over 10 years of expertise, we combine deep technical knowledge with
            customer-first service. Our goal is not just to sell products or install
            systems, but to build lasting relationships by ensuring our clients feel
            supported and secure at every step.
          </p>
        </div>

        {/* Mission Vision Values */}
        <div className="grid-3">
          <div className="card">
            <h3>Our Mission</h3>
            <p>
              To empower individuals and businesses with cutting-edge technology
              solutions and robust security systems, ensuring productivity, protection,
              and peace of mind.
            </p>
          </div>

          <div className="card">
            <h3>Our Vision</h3>
            <p>
              To be recognized as the most trusted IT and security partner in
              Maharashtra and beyond, delivering value through innovation, quality,
              and service excellence.
            </p>
          </div>

          <div className="card">
            <h3>Our Values</h3>
            <ul>
              <li><strong>Trust:</strong> Building relationships on honesty and reliability.</li>
              <li><strong>Innovation:</strong> Staying ahead with the latest technology.</li>
              <li><strong>Quality:</strong> Delivering only the best.</li>
              <li><strong>Commitment:</strong> Always putting customers first.</li>
            </ul>
          </div>
        </div>

        {/* ⭐ NEW – Directors Section */}
        <div className="directors-section">
          <h2 className="directors-title">Our Managing Directors</h2>

          <div className="directors-grid">
            <div className="director-card">
              <div className="director-image">
                <img src={director1} alt="Dnyandeo B Patil" />
              </div>
              <h3>Dnyandeo B Patil</h3>
              <p className="director-role">Managing Director</p>
            </div>

            <div className="director-card">
              <div className="director-image">
                <img src={director2} alt="Gorakh B Patil" />
              </div>
              <h3>Gorakh B Patil</h3>
              <p className="director-role">Managing Director</p>
            </div>
          </div>
        </div>

        {/* Closing */}
        <div className="about-block closing">
          <p>
            At Rohan Systems, we are more than just a technology provider—we are your
            partners in growth, security, and success. Whether you are looking for a
            new laptop, a reliable repair service, or a complete CCTV installation,
            we are here to deliver solutions you can trust.
          </p>
        </div>
      </div>

      <FloatingWhatsApp
        avatar={clinicIcon}
        notification={false}
        accountName="Rohan Systems"
        phoneNumber={PHONE_NUMBER}
        onSubmit={(e) => whatsAppBotListener(e.target[0].value)}
      />
    </section>
  );
};

export default AboutBanner;
